import PropTypes from "prop-types";
import { useEffect } from "react";
import { Table } from "reactstrap";

import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { fetchAttritionRateReport } from "../../../../ReduxToolkit/Reducers/ReportSlice";
import {
  AsOn,
  AttritionPercentage,
  DataHeads,
  Domain,
  getDataReferenceNextYear,
} from "../../../../utils/Constant";
import { formatString } from "../../../../utils/helper/helper";
import "./style.scss";

const AttritionRateTable = ({ domain_id, financial_year }) => {
  const dispatch = useAppDispatch();
  const { attritionRateReportData } = useAppSelector(
    (state: any) => state.report
  );
  const domainList = useAppSelector((state: any) => state.master.domainList);

  let domainName = domain_id;
  if (domainList?.domain) {
    const found = domainList.domain.find(
      (d: any) => String(d.id) === String(domain_id)
    );
    if (found) domainName = found.domain_name;
  }

  useEffect(() => {
    if (domain_id && financial_year) {
      dispatch(fetchAttritionRateReport({ domain_id, financial_year }) as any);
    }
  }, [dispatch, domain_id, financial_year]);

  const nextYear = parseInt(financial_year, 10) + 1;

  const fyShort = String(financial_year).slice(-2);
  const nextYearShort = String(nextYear).slice(-2);

  const headers = [
    {
      key: `Mar/${fyShort}`,
      // value: `${financial_year}-${nextYearShort} Data for reference (in %) (updated as of Mar ${nextYear})`,
      value: getDataReferenceNextYear(financial_year, nextYearShort, nextYear),
      isWideColumn: true,
    },
    { key: `Apr/${fyShort}`, value: `${AsOn} (4/${financial_year})` },
    { key: `May/${fyShort}`, value: `${AsOn} (5/${financial_year})` },
    { key: `Jun/${fyShort}`, value: `${AsOn} (6/${financial_year})` },
    { key: `Jul/${fyShort}`, value: `${AsOn} (7/${financial_year})` },
    { key: `Aug/${fyShort}`, value: `${AsOn} (8/${financial_year})` },
    { key: `Sep/${fyShort}`, value: `${AsOn} (9/${financial_year})` },
    { key: `Oct/${fyShort}`, value: `${AsOn} (10/${financial_year})` },
    { key: `Nov/${fyShort}`, value: `${AsOn} (11/${financial_year})` },
    { key: `Dec/${fyShort}`, value: `${AsOn} (12/${financial_year})` },
    { key: `Jan/${nextYearShort}`, value: `${AsOn} (1/${nextYear})` },
    { key: `Feb/${nextYearShort}`, value: `${AsOn} (2/${nextYear})` },
    { key: `Mar/${nextYearShort}`, value: `${AsOn} (3/${nextYear})` },
  ];

  const generateTableData = () => {
    const tableData = [];
    attritionRateReportData?.forEach(data => {
      tableData.push({
        dataHead: `${data.level} (${AttritionPercentage})`,
        levelKey: data.level,
        key: "attrition_percentage",
        isSubHeader: true,
      });

      Object.keys(data.metrics).forEach(metricKey => {
        if (metricKey !== "attrition_percentage") {
          tableData.push({
            dataHead: formatString(metricKey),
            key: metricKey,
            levelKey: data.level,
          });
        }
      });
    });
    return tableData;
  };

  const tableData = generateTableData();

  const getMonthData = (levelKey, key, monthKey) => {
    const value = attritionRateReportData?.find(item => item.level === levelKey)
      ?.metrics?.[key]?.[monthKey];
    return value !== undefined ? value : "-";
  };

  return (
    <div className="table-container">
      <Table className="attrition-rate-table" bordered>
        <thead>
          <tr>
            <th className="sticky-column domain">{Domain}</th>
            <th className="sticky-column data-heads">{DataHeads}</th>
            {headers.map((item, index) => (
              <th
                key={index}
                className={
                  item?.isWideColumn
                    ? "wide-column month-header"
                    : "month-header"
                }
              >
                {item.value}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <>
                {index === 0 && (
                  <td
                    rowSpan={tableData.length}
                    className="sticky-column domain bold-black"
                  >
                    {domainName}
                  </td>
                )}
                <td
                  className={`sticky-column data-heads ${
                    row.isSubHeader ? "bold-black" : ""
                  }`}
                >
                  {row.dataHead}
                </td>
                {headers.map((header, i) => (
                  <td key={i}>
                    {getMonthData(row.levelKey, row.key, header.key)}
                  </td>
                ))}
              </>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

AttritionRateTable.propTypes = {
  domain_id: PropTypes.string.isRequired,
  financial_year: PropTypes.string.isRequired,
};

export default AttritionRateTable;
